var _path, _path2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogomark(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.9764 45.3334H10.594C9.16139 45.3334 8 44.1782 8 42.7532V5.24698C8 3.82196 9.16139 2.66675 10.594 2.66675H25.5564C35.5175 2.66675 40 9.72625 40 16.7858C40 22.7925 36.8249 28.0562 29.9144 29.7901L38.0924 41.2606C39.3106 42.9692 38.0823 45.3334 35.9764 45.3334Z",
    fill: "url(#paint0_linear_2646_584)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.64,
    d: "M10.6667 2.66675H16V45.3334H10.6667C9.19391 45.3334 8 44.1782 8 42.7532V5.24698C8 3.82196 9.19391 2.66675 10.6667 2.66675Z",
    fill: "url(#paint1_linear_2646_584)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2646_584",
    x1: 24.4981,
    y1: 2.66675,
    x2: 24.4981,
    y2: 45.3334,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2ED4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0088FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2646_584",
    x1: 15.2686,
    y1: 2.66675,
    x2: 15.2686,
    y2: 45.3334,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3525D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3525D3",
    stopOpacity: 0.24
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogomark);
export default __webpack_public_path__ + "static/media/logomark.f4792fc0ef74cd92221a2d7dfbf7b4c3.svg";
export { ForwardRef as ReactComponent };